import { useQueries, useQuery } from '@tanstack/react-query'
import { fetchApiWithToken, getBatchFetcher } from '~/api/utils'
import type { UserPicture } from '../types'

type UserPictureWithId = UserPicture & { id: number }

const userPicturesBatcher = () =>
  getBatchFetcher<UserPictureWithId>('userPictures', async (ids) => {
    const pictures = await fetchApiWithToken<UserPicture[]>({
      method: 'get',
      url: `/v1/users/profile_pics?id[]=${ids.join('&id[]=')}`
    })

    // Add id property to each picture response for the batch fetcher
    return pictures.map((picture) => {
      return {
        ...picture,
        id: picture.user.id
      }
    })
  })

export const useUsersPicture = ({ userIds }: { userIds: number[] }) => {
  return useQueries({
    queries: userIds.map((userId) => ({
      queryKey: ['users', 'picture', userId],
      queryFn: () => userPicturesBatcher().fetch(userId),
      staleTime: Number.POSITIVE_INFINITY,
      refetchOnWindowFocus: false
    }))
  })
}

export const useUserPicture = ({ userId }: { userId?: number }) => {
  return useQuery({
    queryKey: ['users', 'picture', userId],
    queryFn: () =>
      userId ? userPicturesBatcher().fetch(userId) : Promise.resolve(null),
    enabled: !!userId,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false
  })
}
